export default __webpack_public_path__ + "static/media/arrow_right.502575a0.svg";